import { Group } from "../../entities/group.types";
import { GetGroupsApi, GroupsResponse } from "./get-groups.types";
import { apiGateway } from "@/_old/services/api-gateway";

export const getGroupsApi: GetGroupsApi = async (params) => {
  const searchParams = new URLSearchParams();
  searchParams.append("fl", "stats-members");
  searchParams.append("limit", "2000");

  if (params.groupId) {
    searchParams.append("groupId", `${params.groupId}`);
  }

  const { data }: GroupsResponse = await apiGateway.get(
    `/api/v0/companies/${params.companyId}/groups?${searchParams.toString()}`,
  );

  const filteredData = data._embedded.company_groups.map(
    ({ company_group }): Group => ({
      id: company_group.id,
      companyId: company_group.company_id,
      isActive: company_group.is_active,
      name: company_group.name,
      description: company_group.description,
      createdAt: new Date(company_group.created_at),
      updatedAt: new Date(company_group.updated_at),
    }),
  );

  return { groups: filteredData };
};
